import {BI_ERRORS} from '../biErrorLogger/biErrors';
import {errorLogger} from '../errorLogger/errorLogger';
import {dgsRequest} from './dgsRequest';

export const subscribeDownload = ({
  instance,
  paymentsId,
  sToken,
  ref,
  albumId,
  trackId = null,
  email,
}: {
  instance: string;
  paymentsId: string | null;
  sToken: string;
  ref: string;
  albumId: string;
  trackId?: number | null;
  email: string;
}) => {
  return dgsRequest({
    instance,
    paymentsId,
    sToken,
    ref,
    albumId,
    trackId,
    subscribeEmail: email,
  })
    .then(() => ({ok: true}))
    .catch(errorLogger.createLoggingCatcher({bi: BI_ERRORS.getWindow.dgs.subscribeDownload}));
};
